import { INVENTORY_SELECTOR_TYPES } from "./dependerTypes";

const STAY_DATE_WIDGET = "STAY_DATE";

export function buildDependers({ type, dependersBoxes, selectedTickers }) {
  const isInventoryType = INVENTORY_SELECTOR_TYPES.includes(type);
  return [
    {
      type,
      tickers: isInventoryType ? selectedTickers || [] : dependersBoxes || [],
    },
  ];
}

function parseOptionLabels(items) {
  if (typeof items === "string")
    return items
      .split(",")
      .map(label => label.trim())
      .filter(Boolean);
  if (Array.isArray(items)) return items.map(item => item.label);
  return [];
}

// Options are matched across locales BY POSITION, not by label text (label-keying
// duplicated every option per language — WTT-11295); existing value kept for a stable id.
function serializeFieldItems(field) {
  if (field.widgetType === STAY_DATE_WIDGET || !Array.isArray(field.translations)) return [];
  const originalItems = Array.isArray(field.items) ? field.items : [];
  const items = [];
  field.translations.forEach(({ locale, items: localeItems }) => {
    if (!locale) return;
    parseOptionLabels(localeItems).forEach((label, idx) => {
      if (!items[idx]) items[idx] = { value: originalItems[idx]?.value || "", labels: {} };
      items[idx].labels[locale] = label;
    });
  });
  items.forEach(item => {
    item.value = item.value || Object.values(item.labels)[0] || "";
  });
  return items;
}

function serializeFieldTranslations(field) {
  const translationsMap = {};
  field.translations.forEach(({ locale, label, placeholder, description }) => {
    if (locale)
      translationsMap[locale] = {
        label: label || "",
        placeholder: placeholder || null,
        description: description || null,
      };
  });
  return translationsMap;
}

function serializeFields(fields) {
  if (!Array.isArray(fields)) return fields;
  return fields.map(field => {
    if (!Array.isArray(field.translations)) return field;
    return {
      ...field,
      items: serializeFieldItems(field),
      translations: serializeFieldTranslations(field),
    };
  });
}

function serializeTopLevelTranslations(translations) {
  if (!Array.isArray(translations)) return translations;
  const transMap = {};
  translations.forEach(({ locale, ...rest }) => {
    if (locale) transMap[locale] = rest;
  });
  return transMap;
}

function applyFieldConstraints(field) {
  if (typeof field.required === "object") return field;
  const { required, ...rest } = field;
  // Constraints must be a flat Map<String,String>; a nested object 400s in Jackson.
  return { ...rest, constraints: required ? { required: "true" } : {} };
}

export function prepareEntityForSubmit({ formValues, selectedTickers }) {
  const { id, ...rest } = formValues;
  const entityId = id != null && id !== "" && id !== " " ? id : "";
  const active = rest.active === true || rest.active === "true" || rest.active === 1;
  const fields = serializeFields((rest.fields || []).map(applyFieldConstraints));
  const translations = serializeTopLevelTranslations(rest.translations);

  if (typeof rest.dependers !== "object") {
    const { dependersBoxes, ...withoutBoxes } = rest;
    return {
      ...withoutBoxes,
      id: entityId,
      active,
      fields,
      translations,
      dependers: buildDependers({ type: rest.dependers, dependersBoxes, selectedTickers }),
    };
  }
  return { ...rest, id: entityId, active, fields, translations };
}

export const __test__ = {
  parseOptionLabels,
  serializeFieldItems,
  serializeFieldTranslations,
  serializeFields,
  serializeTopLevelTranslations,
  applyFieldConstraints,
};
